import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// v_agencia_funil_vagas (sql/161) ainda não está no types.ts gerado -> cast,
// mesmo padrão do useAgenciaResumo (view nova fora do types.ts).
const funilDb = supabase as unknown as {
  from: (table: string) => any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

/** Linha de v_agencia_funil_vagas (sql/161): funil de vagas de 1 agência. */
export interface AgenciaFunilVagas {
  agencia_id: string;
  agencia_nome: string;
  vagas_criadas: number;
  vagas_aprovadas: number;
  vagas_reprovadas: number;
  vagas_em_andamento: number;
  taxa_aprovacao: number | null;
  tempo_medio_dias_ate_terminal: number | null;
  primeira_vaga_em: string | null;
  ultima_vaga_em: string | null;
}

/**
 * Funil de vagas comparativo entre agências (v_agencia_funil_vagas, sql/161):
 * criadas/aprovadas/reprovadas/em andamento, taxa de aprovação e tempo médio
 * até o desfecho, 1 linha por agência. View interna (a própria RLS da view já
 * bloqueia usuário de portal de agência); a tela de Dashboard interno é
 * protegida por requiredScreen="dashboard" antes de chegar aqui.
 */
export function useAgenciaFunilComparativo() {
  return useQuery({
    queryKey: ["agencia-funil-comparativo"],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<AgenciaFunilVagas[]> => {
      const { data, error } = await funilDb.from("v_agencia_funil_vagas").select("*");
      if (error) throw error;
      return (data as AgenciaFunilVagas[]) ?? [];
    },
  });
}
